<template>
  <div class="helppage">
    <div class="help-intro">
      <div class="content-wrapper">
        <div class="help-back">
          <b-button variant="link">
            <img src="@/assets/images/help-center/left.svg" alt="left" />
            <router-link :to="{ name: 'Landingpage' }" class="mx-auto backtext">
              Zurück
            </router-link>
          </b-button>
        </div>
      </div>

      <div class="help-header">
        <h2>So funktioniert der Online-Uhren&Schmuck-Service</h2>
      </div>
      <div class="help-process-wrapper">
        <div>
          <div class="help-process">
            <div class="help-process-item">
              <img
                class="help-process-item-nr"
                src="@/assets/images/help-center/schritt_1_weiss.svg"
                alt="Schritt 1"
              />
              <img
                class="help-process-item-pic"
                src="@/assets/images/help-center/laptop.svg"
                alt="Laptop"
              />
            </div>
            <div class="help-process-item arrow">
              <img
                class="help-process-arrow"
                src="@/assets/images/help-center/arrow.svg"
                alt="Arrow"
              />
            </div>
            <div class="help-process-item">
              <img
                class="help-process-item-nr"
                src="@/assets/images/help-center/schritt_2_weiss.svg"
                alt="Schritt 2"
              />
              <img
                class="help-process-item-pic"
                src="@/assets/images/help-center/mail + check.svg"
                alt="Checked Mail"
              />
            </div>
            <div class="help-process-item arrow">
              <img
                class="help-process-arrow"
                src="@/assets/images/help-center/arrow.svg"
                alt="Arrow"
              />
            </div>
            <div class="help-process-item">
              <img
                class="help-process-item-nr"
                src="@/assets/images/help-center/schritt_3_weiss.svg"
                alt="Schritt 3"
              />
              <img
                class="help-process-item-pic"
                id="checked-mail"
                src="@/assets/images/help-center/paket.svg"
                alt="Checked Mail"
              />
            </div>
            <div class="help-process-item arrow">
              <img
                class="help-process-arrow"
                id="top-arrow"
                src="@/assets/images/help-center/arrow.svg"
                alt="Arrow"
              />
            </div>
          </div>
          <div class="help-process">
            <div class="help-process-item">
              <img
                class="help-process-item-nr"
                src="@/assets/images/help-center/schritt_4_weiss.svg"
                alt="Schritt 4"
              />
              <img
                class="help-process-item-pic"
                src="@/assets/images/help-center/laptop-mail-return.svg"
                alt="Mail Return"
              />
            </div>
            <div class="help-process-item arrow">
              <img
                class="help-process-arrow"
                src="@/assets/images/help-center/arrow.svg"
                alt="Arrow"
              />
            </div>
            <div class="help-process-item">
              <img
                class="help-process-item-nr"
                src="@/assets/images/help-center/schritt_5_weiss.svg"
                alt="Schritt 2"
              />
              <img
                class="help-process-item-pic"
                src="@/assets/images/help-center/repair.svg"
                alt="Repair"
              />
            </div>
            <div class="help-process-item arrow">
              <img
                class="help-process-arrow"
                src="@/assets/images/help-center/arrow.svg"
                alt="Arrow"
              />
            </div>
            <div class="help-process-item">
              <img
                class="help-process-item-nr"
                src="@/assets/images/help-center/schritt_6_weiss.svg"
                alt="Schritt 6"
              />
              <img
                class="help-process-item-pic"
                src="@/assets/images/help-center/deliver.svg"
                alt="Delivery"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="help-accordion">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="info">
              <img
                src="@/assets/images/help-center/schritt_1.svg"
                alt="Schritt 1"
                class="accordion-counter"
              />
              <span class="accordion-title"
                >Auftrag wurde erfasst</span
              >
              <img
                src="@/assets/images/help-center/down.svg"
                class="accordion-icon"
                alt="Down Icon"
              />
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                Problemanalyse und Fehlerbeschreibung mit Ihren Kontaktdaten wurden online erfasst und erfolgreich abgeschickt.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-2 variant="info">
              <img
                src="@/assets/images/help-center/schritt_2.svg"
                alt="Schritt 2"
                class="accordion-counter"
              />
              <span class="accordion-title"
                >Auftrag ist bei CHRIST eingegangen</span
              >
              <img
                src="@/assets/images/help-center/down.svg"
                class="accordion-icon"
                alt="Down Icon"
              />
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                Unser System ermittelt basierend auf Ihren Antworten die notwendigen Service-Leistungen. Bei Rückfragen zum Auftrag werden wir mit Ihnen Kontakt aufnehmen, bevor Sie den Artikel an uns versenden.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-3 variant="info">
              <img
                src="@/assets/images/help-center/schritt_3.svg"
                alt="Schritt 3"
                class="accordion-counter"
              />
              <span class="accordion-title">Paket Versand</span>
              <img
                src="@/assets/images/help-center/down.svg"
                class="accordion-icon"
                alt="Down Icon"
              />
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                Nach Erhalt unseres Versandscheins versenden Sie Ihren Artikel an die CHRIST-Service-Werkstatt in einem geeigneten stabilen Paket.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-4 variant="info">
              <img
                src="@/assets/images/help-center/schritt_4.svg"
                alt="Schritt 4"
                class="accordion-counter"
              />
              <span class="accordion-title"
                >Empfangsbestätigung von CHRIST</span
              >
              <img
                src="@/assets/images/help-center/down.svg"
                class="accordion-icon"
                alt="Down Icon"
              />
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                Sobald das Paket mit Ihrem Artikel bei uns angekommen ist, bestätigen wir Ihnen den Erhalt per E-Mail.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-5 variant="info">
              <img
                src="@/assets/images/help-center/schritt_5.svg"
                alt="Schritt 5"
                class="accordion-counter"
              />
              <span class="accordion-title">Reparatur/Anfertigung/Umarbeitung Ihres Artikels</span>
              <img
                src="@/assets/images/help-center/down.svg"
                class="accordion-icon"
                alt="Down Icon"
              />
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                Eine professionelle Reparatur, Anfertigungo oder Umarbeitung Ihres Artikels wird in unserer CHRIST-Service-Werkstatt durchgeführt. Bei Unklarheiten oder Preisabweichungen nehmen wir direkt Kontakt mit Ihnen auf. Sie erhalten einen unverbindlichen Kostenvoranschlag zur Freigabe, bevor wir Ihren Auftrag final ausführen.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1" style="border: unset !important">
          <b-card-header
            header-tag="header"
            class="p-1"
            role="tab"
            style="border: unset !important"
          >
            <b-button block v-b-toggle.accordion-6 variant="info">
              <img
                src="@/assets/images/help-center/schritt_6.svg"
                alt="Schritt 6"
                class="accordion-counter"
              />
              <span class="accordion-title">Kostenloser Rückversand</span>
              <img
                src="@/assets/images/help-center/down.svg"
                class="accordion-icon"
                alt="Down Icon"
              />
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                Es erfolgt der kostenlose Rückversand Ihres Artikels, sowie der Rechnung an die von Ihnen angegebene Adresse.
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="help-flow-tablet">
        <div class="help-flow-row">
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_1.svg"
              alt="Schritt 1"
            />
            <div>
              <h4>Auftrag wurde erfasst</h4>
              <span>
                Problemanalyse und Fehlerbeschreibung mit Ihren Kontaktdaten wurden online erfasst und erfolgreich abgeschickt.
              </span>
            </div>
          </div>
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_2.svg"
              alt="Schritt 2"
            />
            <div>
              <h4>Auftrag ist bei CHRIST eingegangen</h4>
              <span>
                Unser System ermittelt basierend auf Ihren Antworten die notwendigen Service-Leistungen.
                Bei Rückfragen zum Schaden werden wir mit Ihnen Kontakt aufnehmen, bevor Sie den Artikel an uns versenden.
              </span>
            </div>
          </div>
        </div>
        <hr class="flow-separator" />
        <div class="help-flow-row">
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_3.svg"
              alt="Schritt 3"
            />
            <div>
              <h4>Paket Versand</h4>
              <span>
                Nach Erhalt unseres Versandscheins versenden Sie den Artikel an die CHRIST-Service-Werkstatt in einem geeigneten stabilen Paket.
              </span>
            </div>
          </div>
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_4.svg"
              alt="Schritt 4"
            />
            <div>
              <h4>Empfangsbestätigung von CHRIST</h4>
              <span>
                Sobald das Paket mit Ihrem Artikel bei uns angekommen ist, bestätigen wir Ihnen den Erhalt per E-Mail.
              </span>
            </div>
          </div>
        </div>
        <hr class="flow-separator" />
        <div class="help-flow-row">
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_5.svg"
              alt="Schritt 5"
            />
            <div>
              <h4>Reparatur/Anfertigung/Umarbeitung Ihres Artikels</h4>
              <span>
                Eine professionelle Reparatur, Anfertigung oder Umarbeitung Ihres Artikels wird in unserer CHRIST-Service-Werkstatt durchgeführt. Bei Unklarheiten oder Preisabweichungen nehmen wir direkt Kontakt mit Ihnen auf. Sie erhalten einen unverbindlichen Kostenvoranschlag zur Freigabe, bevor wir Ihren Auftrag final ausführen.
              </span>
            </div>
          </div>
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_6.svg"
              alt="Schritt 6"
            />
            <div>
              <h4>Kostenloser Rückversand</h4>
              <span>
                Es erfolgt der kostenlose Rückversand Ihres Artikels, sowie der Rechnung an die von Ihnen angegebene Adresse.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="help-flow-desktop">
        <div class="help-flow-row">
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_1.svg"
              alt="Schritt 1"
            />
            <div>
              <h4>Auftrag wurde erfasst</h4>
              <span>
                Problemanalyse und Fehlerbeschreibung mit Ihren Kontaktdaten wurden online erfasst und erfolgreich abgeschickt.
              </span>
            </div>
          </div>
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_2.svg"
              alt="Schritt 2"
            />
            <div>
              <h4>Auftrag ist bei CHRIST eingegangen</h4>
              <span>
                Unser System ermittelt basierend auf Ihren Antworten die notwendigen Service-Leistungen.
                Bei Rückfragen zum Schaden werden wir mit Ihnen Kontakt aufnehmen, bevor Sie den Artikel an uns versenden.
              </span>
            </div>
          </div>
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_3.svg"
              alt="Schritt 3"
            />
            <div>
              <h4>Paket Versand</h4>
              <span>
                Nach Erhalt unseres Versandscheins versenden Sie den Artikel an die CHRIST-Service-Werkstatt in einem geeigneten stabilen Paket.
              </span>
            </div>
          </div>
        </div>
        <hr class="flow-separator" />
        <div class="help-flow-row">
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_4.svg"
              alt="Schritt 4"
            />
            <div>
              <h4>Empfangsbestätigung von CHRIST</h4>
              <span>
                Sobald das Paket mit Ihrem Artikel bei uns angekommen ist, bestätigen wir Ihnen den Erhalt per E-Mail.
              </span>
            </div>
          </div>
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_5.svg"
              alt="Schritt 5"
            />
            <div>
              <h4>Reparatur/Anfertigung/Umarbeitung Ihres Artikels</h4>
              <span>
                Eine professionelle Reparatur, Anfertigung oder Umarbeitung Ihres Artikels wird in unserer CHRIST-Service-Werkstatt durchgeführt. Bei Unklarheiten oder Preisabweichungen nehmen wir direkt Kontakt mit Ihnen auf. Sie erhalten einen unverbindlichen Kostenvoranschlag zur Freigabe, bevor wir Ihren Auftrag final ausführen.
              </span>
            </div>
          </div>
          <div class="help-flow-step">
            <img
              src="@/assets/images/help-center/schritt_6.svg"
              alt="Schritt 6"
            />
            <div>
              <h4>Kostenloser Rückversand</h4>
              <span>
                Es erfolgt der kostenlose Rückversand Ihres Artikels, sowie der Rechnung an die von Ihnen angegebene Adresse.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="help-faq">
        <div class="help-faq-header">
          <h3>Fragen und Antworten</h3>
          <span
            >Hier finden Sie Fragen und Antworten rund um den CHRIST
            Online-Uhren&Schmuck-Service</span
          >
        </div>
        <div class="help-faq-content">
          <b-card
            no-body
            class="mb-1"
            v-for="question in faqList"
            :key="question.id"
          >
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle="'faq' + question.id"
                variant="info"
                class="faq-btn"
              >
                <img
                  class="faq1_img_open"
                  src="@/assets/images/help-center/plus_icon.svg"
                  alt="Geoeffnet"
                />
                <img
                  class="faq1_img_closed"
                  src="@/assets/images/help-center/minus.svg"
                  alt="Geschlossen"
                />
                {{ question.question }}
              </b-button>
            </b-card-header>
            <b-collapse
              :id="'faq' + question.id"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="faq-content-text">
                  {{ question.content }}
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Help",
  data() {
    return {
      orderedList: null,
    };
  },
  mounted() {
    if (!this.$store.state.faq.faqList.length) {
      this.$store.dispatch("loadFaq");
    }
  },
  computed: mapState({
    faqList: (state) => state.faq.faqList,
  }),
  methods: {},
};
</script>
